import React, { useEffect } from 'react';
import { useField } from 'formik';
// import { useTranslation } from 'react-i18next';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormField from '~/commons/components/FormField.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsMatching = ({
  idx,
  qtnIndex: i,
  restrictEdit = false,
}) => {
  const [, { value }] = useField(`questionSets[${idx}].questions.${i}`);
  const [,, { setValue: setAns }] = useField(`questionSets[${idx}].questions.${i}.answers`);
  const [,, { setValue: setMatches }] = useField(`questionSets[${idx}].questions.${i}.matches`);
  // const { t } = useTranslation();
  let { choices } = value;
  const { answers, matches } = value;

  // take out the last empty choice
  if (!restrictEdit && !choices.slice(-1)[0]) {
    choices = choices.slice(0, -1);
  }

  useEffect(() => {
    if (
      answers.length !== choices.length
      || matches.length !== choices.length
    ) {
      // ensure right number of answers and matches
      let a = answers.slice(0, choices.length);
      const m = matches.slice(0, choices.length);

      a.push(...choices.slice(a.length).map(() => null));
      m.push(...choices.slice(m.length).map(() => ''));
      // make sure answers are within one of the choices
      a = a.map((k, ii) => (
        k === null || k >= choices.length
          ? ii.toString() : k.toString()
      ));

      setAns(a);
      setMatches(m);
    }
  }, [choices.length]);

  return (
    <div className="row">
      <div className="col">
        <label>線索 *</label>
        <FieldArrayIterables
          name={`questionSets[${idx}].questions.${i}.choices`}
          {...restrictEdit ? {} : {
            tail: '',
          }}
        >
          {(c, ii) => (
            <div
              className="form-row align-items-center"
              key={ii}
            >
              <div className="col-auto pb-3">
                {(ii+1)}.
              </div>
              <div className="col">
                <FormGroup
                  name={`questionSets[${idx}].questions.${i}.choices.${ii}`}
                  label={null}
                />
              </div>
            </div>
          )}
        </FieldArrayIterables>
      </div>
      <div className="col">
        <label>配對 *</label>
        {matches.map((m, ii) => (
          <FormGroup
            key={ii}
            name={`questionSets[${idx}].questions.${i}.matches.${ii}`}
            label={null}
            prepend={(
              <div className='d-flex'>
              <FormField
                name={`questionSets[${idx}].questions.${i}.answers.${ii}`}
                as="select"
              >
                {choices.map((c, iii) => (
                  <option
                    key={iii}
                    value={iii}
                  >{(iii+1)}</option>
                ))}
              </FormField>
              <div className="d-flex align-items-center p-2">{numToLetter(ii, true)}.</div>
              </div>
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default FieldsMatching;
